import glamorous from 'glamorous';
const EventList = glamorous.div({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  justifyContent: 'center',
});

export default EventList;



// WEBPACK FOOTER //
// ./src/App/events/components/EventList.js